import { motion } from 'framer-motion';
import GlassCard from '../ui/GlassCard';

export default function Testimonials() {
    const testimonials = [
        {
            quote: "The AI feedback was incredibly accurate. It caught filler words I didn't even know I was using.",
            author: "Sarah L.",
            role: "Product Manager @ Google",
            initials: "SL"
        },
        {
            quote: "PitchMe.AI helped me structure my answers better. I felt so much more confident during my real interview.",
            author: "Michael Chen",
            role: "Software Engineer @ Meta",
            initials: "MC"
        },
        {
            quote: "The industry-specific questions were a game changer. It felt like I was practicing with a real hiring manager.",
            author: "Jessica P.",
            role: "UX Designer @ Airbnb",
            initials: "JP"
        }
    ];

    return (
        <section id="testimonials" className="py-32 relative">
            <div className="max-w-7xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-20"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-6">
                        Trusted by Professionals <br />
                        <span className="text-gradient">Worldwide</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <GlassCard key={index} delay={index * 0.1} className="flex flex-col h-full">
                            <div className="mb-6 text-blue-400">
                                <i className="ri-double-quotes-l text-4xl"></i>
                            </div>
                            <p className="text-lg text-zinc-300 mb-8 flex-grow leading-relaxed">
                                "{testimonial.quote}"
                            </p>
                            <div className="flex items-center gap-4 mt-auto">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-sm">
                                    {testimonial.initials}
                                </div>
                                <div>
                                    <h4 className="font-semibold text-white">{testimonial.author}</h4>
                                    <p className="text-sm text-zinc-500">{testimonial.role}</p>
                                </div>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </div>
        </section>
    );
}
